/**
 * T&T Cart Drawer
 * Talks to Shopify's native Cart AJAX API (/cart/add.js, /cart/change.js, /cart/update.js, /cart.js).
 * Mirrors the money-formatting and data-attribute conventions already used on the
 * full cart page (tnt-cart.liquid) so both stay visually and behaviorally consistent.
 */
(function () {
  var drawer, body;

  function money(cents) {
    if (window.Shopify && Shopify.formatMoney && window.themeMoneyFormat) {
      return Shopify.formatMoney(cents, window.themeMoneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Resolve the drawer lazily rather than relying on a variable cached at init.
  // If the section renders later, or init ran before it was in the DOM, this
  // still finds it instead of silently doing nothing.
  function getDrawer() {
    if (!drawer) drawer = document.getElementById('tnt-cart-drawer');
    return drawer;
  }

  function openDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('tnt-cart-drawer-open');
  }

  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('tnt-cart-drawer-open');
  }

  function setRowBusy(row, busy) {
    if (row) row.style.opacity = busy ? '.4' : '1';
  }

  function updateHeaderCount(count) {
    var el = document.querySelector('[data-tnt-cart-count]');
    var link = document.getElementById('tnt-header-cart-link');
    if (count > 0) {
      if (el) {
        el.textContent = count;
      } else if (link) {
        var span = document.createElement('span');
        span.className = 'tnt-cart-count';
        span.setAttribute('data-tnt-cart-count', '');
        span.textContent = count;
        link.appendChild(span);
      }
    } else if (el) {
      el.remove();
    }
  }

  function renderRow(item) {
    var variantLine = item.variant_title && item.variant_title !== 'Default Title'
      ? '<span class="tnt-cart-drawer__variant">' + item.variant_title + '</span>'
      : '';
    var vendorLine = document.body.dataset.tntShowVendor === 'true'
      ? '<span class="tnt-cart-drawer__vendor">' + item.vendor + '</span>'
      : '';
    var img = item.image
      ? '<img src="' + item.image.replace(/(\.[a-zA-Z0-9]+)(\?|$)/, '_200x$1$2') + '" alt="' + (item.product_title || '') + '" loading="lazy" width="100">'
      : '';

    return (
      '<div class="tnt-cart-drawer__row" data-tnt-cart-row data-line-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="tnt-cart-drawer__img">' + img + '</a>' +
        '<div class="tnt-cart-drawer__info">' +
          vendorLine +
          '<a href="' + item.url + '" class="tnt-cart-drawer__title">' + item.product_title + '</a>' +
          variantLine +
          '<div class="tnt-cart-drawer__qty" data-tnt-qty-wrap>' +
            '<button type="button" data-tnt-qty-down data-line-key="' + item.key + '" aria-label="Decrease quantity">&#8722;</button>' +
            '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-tnt-qty-input readonly>' +
            '<button type="button" data-tnt-qty-up data-line-key="' + item.key + '" aria-label="Increase quantity">&#43;</button>' +
          '</div>' +
        '</div>' +
        '<div class="tnt-cart-drawer__right">' +
          '<span class="tnt-cart-drawer__price" data-tnt-line-price>' + money(item.final_line_price) + '</span>' +
          '<button type="button" class="tnt-cart-drawer__remove" data-tnt-cart-remove data-line-key="' + item.key + '">Remove</button>' +
        '</div>' +
      '</div>'
    );
  }

  function applyCartState(cart) {
    updateHeaderCount(cart.item_count);

    var label = document.getElementById('tnt-drawer-count-label');
    if (label) label.textContent = cart.item_count + (cart.item_count === 1 ? ' Item' : ' Items');

    var subtotal = document.getElementById('tnt-drawer-subtotal');
    if (subtotal) subtotal.textContent = money(cart.total_price);

    var checkoutBtn = document.getElementById('tnt-drawer-checkout-btn');
    if (checkoutBtn) {
      var svg = checkoutBtn.querySelector('svg');
      checkoutBtn.innerHTML = (svg ? svg.outerHTML : '') + ' Checkout &mdash; ' + money(cart.total_price);
    }

    var itemsWrap = document.getElementById('tnt-cart-drawer-items');
    var emptyState = document.getElementById('tnt-cart-drawer-empty');
    var footer = document.querySelector('.tnt-cart-drawer__footer');
    var isEmpty = cart.item_count === 0;

    // The Liquid may hide these on an empty page load with either an inline
    // style or a `hidden` attribute. Set both, in both directions, so the
    // footer (subtotal + Checkout) reappears after the first add to cart.
    if (emptyState) {
      emptyState.hidden = !isEmpty;
      emptyState.style.display = isEmpty ? '' : 'none';
    }
    if (footer) {
      footer.hidden = isEmpty;
      footer.style.display = isEmpty ? 'none' : '';
    }
    if (itemsWrap) {
      itemsWrap.innerHTML = isEmpty ? '' : cart.items.map(renderRow).join('');
    }
  }

  function refreshCartState() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(applyCartState)
      .catch(function () {});
  }

  function changeLine(lineKey, quantity, row) {
    setRowBusy(row, true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setRowBusy(row, false);
        applyCartState(cart);
      })
      .catch(function () {
        setRowBusy(row, false);
        refreshCartState();
      });
  }

  function updateNote(note) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    }).catch(function () {});
  }

  // The T&T product page's Add to Cart form (#tnt-product-form) is a plain,
  // unenhanced <form> tag, action="/cart/add", not wrapped in Craft's native
  // <product-form> component. That means it does a normal browser navigation on
  // submit, cart.js's PUB_SUB_EVENTS.cartUpdate broadcast never fires for it,
  // since the JS that publishes that event never runs. This intercepts this
  // specific form's submit directly and does the AJAX add ourselves instead.
  function handleProductFormSubmit(e) {
    var form = e.target;
    // NOTE: do NOT use form.id here. Shopify product forms contain a hidden
    // input named "id" (the variant ID), and HTML named-property access makes
    // form.id resolve to that INPUT ELEMENT rather than the form's id
    // attribute. Comparing it to a string always fails silently.
    // getAttribute('id') reads the real attribute and isn't shadowed.
    if (form.getAttribute('id') !== 'tnt-product-form') return;
    e.preventDefault();

    var submitBtn = form.querySelector('#tnt-atc') || form.querySelector('[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;

    var fd = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status) {
          // Shopify returns an error payload (e.g. sold out, quantity limits)
          // with a 4xx status and a `status`/`description` field rather than
          // throwing. Surface it plainly rather than silently failing.
          console.error('Add to cart failed:', data.description || data.message);
          alert(data.description || 'This item could not be added to your cart.');
          return;
        }
        refreshCartState();
        openDrawer();
      })
      .catch(function (err) {
        console.error('Add to cart request failed:', err);
      })
      .finally(function () {
        if (submitBtn) submitBtn.disabled = false;
      });
  }

  function init() {
    // No early return here. Previously this bailed out if #tnt-cart-drawer
    // wasn't found, which silently prevented every listener below from
    // attaching, including the add-to-cart form interception. All handlers
    // now guard themselves individually instead.
    drawer = document.getElementById('tnt-cart-drawer');
    body = document.getElementById('tnt-cart-drawer-body');

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tnt-cart-drawer-open]')) {
        e.preventDefault();
        refreshCartState();
        openDrawer();
      }
      if (e.target.closest('[data-tnt-cart-drawer-close]')) {
        closeDrawer();
      }

      var up = e.target.closest('[data-tnt-qty-up]');
      var down = e.target.closest('[data-tnt-qty-down]');
      var remove = e.target.closest('[data-tnt-cart-remove]');

      if (up) {
        var row1 = up.closest('[data-tnt-cart-row]');
        var input1 = row1.querySelector('[data-tnt-qty-input]');
        changeLine(up.getAttribute('data-line-key'), parseInt(input1.value, 10) + 1, row1);
      }
      if (down) {
        var row2 = down.closest('[data-tnt-cart-row]');
        var input2 = row2.querySelector('[data-tnt-qty-input]');
        var newQty = parseInt(input2.value, 10) - 1;
        changeLine(down.getAttribute('data-line-key'), Math.max(newQty, 0), row2);
      }
      if (remove) {
        var row3 = remove.closest('[data-tnt-cart-row]');
        changeLine(remove.getAttribute('data-line-key'), 0, row3);
      }
    });

    document.addEventListener('keydown', function (e) {
      var d = getDrawer();
      if (e.key === 'Escape' && d && d.classList.contains('is-open')) closeDrawer();
    });

    var noteField = document.querySelector('[data-tnt-cart-note]');
    if (noteField) {
      var debounce;
      noteField.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { updateNote(noteField.value); }, 500);
      });
    }

    // Confirmed via DOM inspection: #tnt-product-form is a plain form, not the
    // native <product-form> component, so this listener is what actually makes
    // Add to Cart open the drawer on the real product template.
    document.addEventListener('submit', handleProductFormSubmit);

    // product-form.js already performs the real /cart/add.js request and
    // broadcasts PUB_SUB_EVENTS.cartUpdate on success. Rather than submit a
    // second, competing request ourselves, we listen for that same broadcast
    // and open the drawer once it fires. Guards against subscribe/PUB_SUB_EVENTS
    // not existing in case this ever loads on a page without the theme's core
    // cart scripts present.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'product-form') {
          refreshCartState();
          openDrawer();
        }
      });
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();